import { defineComponent as u, mergeModels as a, useModel as c, ref as f, watch as k, onMounted as y, createBlock as p, openBlock as i, Teleport as C, createVNode as v, Transition as b, withCtx as w, createElementBlock as $, createCommentVNode as s, normalizeClass as g, createElementVNode as h, normalizeStyle as B, renderSlot as V, unref as E } from "vue";
import { o as L } from "./index-gabsy7_d.js";
import "./vue3-lottie.es-BQlzj7s3.js";
import "./style-R_nxVIjQ.js";
/* empty css                                                */
/* empty css                                                         */
/* empty css                                                    */
import "./useDatePicker-DAFR8Jnp.js";
import "../config/index.js";
/* empty css                                                           */
import { _ as M } from "./UiIconButton.vue_vue_type_script_setup_true_lang-bU5oojc8.js";
/* empty css                                                       */
/* empty css                                                   */
/* empty css                                                  */
/* empty css                                                    */
/* empty css                                                    */
/* empty css                                                    */
import { toogleHiddenClass as R } from "../helpers/toogleHiddenClass.js";
/* empty css                                                  */
/* empty css                                                      */
import "vue-router";
/* empty css                                                */
/* empty css                                                 */
/* empty css                                                      */
/* empty css                                                        */
/* empty css                                                    */
/* empty css                                                */
/* empty css                                                    */
/* empty css                                                               */
/* empty css                                                    */
const po = /* @__PURE__ */ u({
  __name: "UiModal",
  props: /* @__PURE__ */ a({
    isShowBtnClose: { type: Boolean, default: !0 },
    disabled: { type: Boolean },
    padding: { default: "30" },
    borderRadius: { default: "12" },
    width: {},
    background: { default: "#fff" },
    popperClass: { default: "" },
    positionTop: {},
    positionLeft: {}
  }, {
    modelValue: { type: Boolean, default: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ a(["close"], ["update:modelValue"]),
  setup(l, { emit: d }) {
    const m = d, e = c(l, "modelValue"), r = f();
    L(r, t);
    function t() {
      e.value = !1, m("close"), document.removeEventListener("keydown", n);
    }
    k(e, () => R(e.value));
    const n = (o) => {
      o.key === "Escape" && t();
    };
    return y(() => {
      document.addEventListener("keydown", n);
    }), (o, T) => (i(), p(C, { to: "body" }, [
      v(b, { name: "fade" }, {
        default: w(() => [
          e.value ? (i(), $("div", {
            key: 0,
            class: g(["ui-modal", [o.popperClass]])
          }, [
            h("div", {
              ref_key: "contentRef",
              ref: r,
              class: "ui-modal__content",
              style: B({
                background: o.background,
                padding: `${o.padding}px`,
                borderRadius: `${o.borderRadius}px`,
                width: `${o.width}px`,
                top: `${o.positionTop}px`,
                left: `${o.positionLeft}px`,
                transform: `translate(${o.positionLeft !== void 0 ? "0" : "-50%"}, ${o.positionTop !== void 0 ? "0" : "-50%"})`
              })
            }, [
              V(o.$slots, "default"),
              o.isShowBtnClose ? (i(), p(E(M), {
                key: 0,
                class: "ui-modal__close-icon",
                "no-size": "",
                size: "sm",
                "icon-color": "var(--color-icon-tertiary)",
                onClick: t,
                "icon-name": "close",
                "icon-type": "400",
                tabindex: "-1"
              })) : s("", !0)
            ], 4)
          ], 2)) : s("", !0)
        ]),
        _: 3
      })
    ]));
  }
});
export {
  po as _
};
